import ConfirmModal from 'approot/shared/confirm-modal/confirm-modal';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import Text from 'approot/shared/styles/typography/text';

type Props = {
  isLoading: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
};

const AssignmentModalConfirmClose = ({
  isLoading,
  handleClose,
  handleConfirm,
}: Props) => {
  return (
    <ConfirmModal
      isVisible
      shortTitle="Close this Assignment?"
      handleClose={handleClose}
      actions={
        <>
          <PrimaryButton
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}
          >
            Close Assignment
          </PrimaryButton>
          <SecondaryButton disabled={isLoading} onClick={handleClose}>
            Keep Open
          </SecondaryButton>
        </>
      }
    >
      <Text>
        Students will still be able to view their work, but won’t be able to
        make changes. You can reopen this Assignment later if needed.
      </Text>
    </ConfirmModal>
  );
};

export default AssignmentModalConfirmClose;
